// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3emRJ","additionalInfo":"AgreementModal_additionalInfo__1992T"};